import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Image, Typography, Table, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined, UnorderedListOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function Categories() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [categories, setCategories] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editCategory, setEditCategory] = useState(null);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [dropdownCategories, setDropdownCategories] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        fetchCategories();
        fetchDropdownCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/category/all`, { headers });
            setCategories(response.data);
            setFilteredCategories(response.data);
        } catch (error) {
            AlertError("Failed to fetch categories");
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (category) => {
        setEditCategory(category);
        form.setFieldsValue({
            categoryCode: category.categoryCode,
            categoryName: category.categoryName,
            categoryActiveStatus: category.categoryActive === "True",
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateCategory = async () => {
        try {
            const values = await form.validateFields();

            const requestData = {
                categoryCode: values.categoryCode,
                categoryName: values.categoryName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/category/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Category successfully added!");
                handleCancel();
                fetchCategories();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add category!");
        }
    };
    const handleUpdateCategory = async () => {
        try {
            const values = await form.validateFields();
            const requestData = {
                categoryId: editCategory.categoryId,
                categoryCode: values.categoryCode,
                categoryName: values.categoryName,
                categoryActiveStatus: values.categoryActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/master/category/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Category successfully updated!");
                handleCancel();
                fetchCategories();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to update category!");
        }
    };

    const handleDeleteCategory = async (id) => {
        try {
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/master/category/delete/${id}`, { headers });
            AlertSuccess("Category deleted successfully!");
            fetchCategories();
        } catch (error) {
            AlertError("Failed to delete category!");
        }
    };

    const fetchDropdownCategories = async () => {
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/category/dropdown`, { headers });
            setDropdownCategories(response.data);
        } catch (error) {
            AlertError("Failed to fetch categories for dropdown");
        }
    };

    
    const handleFilter = () => {
        let filtered = categories;

        if (selectedCategory) {
            filtered = filtered.filter(category => category.categoryId === selectedCategory);
        }

        if (keyword) {
            filtered = filtered.filter(category => category.categoryName.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredCategories(filtered);
    };

   
    const handleReset = () => {
        setKeyword('');
        setSelectedCategory(null);
        setFilteredCategories(categories);
    };

    const handleViewSubcategories = (categoryId) => {
        const selectedCategory = categories.find(cat => cat.categoryId === categoryId);
        if (selectedCategory && selectedCategory.categoryName) {
            localStorage.setItem(`categoryName_${categoryId}`, selectedCategory.categoryName);
        }

        navigate(`/master/subcategories/${categoryId}`);
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="View Subcategories">
                        <Button 
                            type="link" 
                            icon={<UnorderedListOutlined />} 
                            onClick={() => handleViewSubcategories(record.categoryId)}
                        />
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    
                    <Popconfirm
                        title="Are you sure to delete this category?"
                        onConfirm={() => handleDeleteCategory(record.categoryId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'Category Name',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: (a, b) => a.categoryName.localeCompare(b.categoryName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'categoryActive',
            key: 'categoryActive',
            render: (categoryActive) => (
                <Tag color={categoryActive === "True" ? "green" : "red"}>
                    {categoryActive === "True" ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item>Categories</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'20px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        <Row style={{display:"flex",justifyContent:'space-between'}}>
                       
                                {/* <Col xs={24} md={12}>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select Category"
                                        value={selectedCategory}
                                        onChange={setSelectedCategory}
                                    >
                                        <Option value={null}>All Categories</Option>
                                        {dropdownCategories.map((category) => (
                                            <Option key={category.id} value={category.id}>{category.label}</Option>
                                        ))}
                                    </Select>
                                </Col> */}
                                <Col xs={24} md={12}>
                                    <Input
                                        placeholder="Search by keyword"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </Col>
                                <Col xs={24} md={8} style={{display:"flex",justifyContent:'flex-end',justifySelf:'flex-end',}}>
                                    <Button type="primary" onClick={handleFilter} style={{ width: "50%",margin:"0" }} >Filter</Button>
                                    <Button style={{ marginLeft: '10px' ,width: "50%"}} onClick={handleReset}>Reset</Button>
                                </Col>


                            

                        </Row>
                        <Typography.Title level={5}>List of Categories</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredCategories}
                            rowKey="categoryId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Category"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateCategory}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Category Code"
                        name="categoryCode"
                        rules={[
                            { required: true, message: "Category code is required" },
                            { len: 4, message: "Category code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item>

                    <Form.Item
                        label="Category Name"
                        name="categoryName"
                        rules={[{ required: true, message: "Category name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Category"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateCategory}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Category Code"
                        name="categoryCode"
                        rules={[{ required: true, message: "Category code is required" }, { len: 4, message: "Category code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item>
                    <Form.Item
                        label="Category Name"
                        name="categoryName"
                        rules={[{ required: true, message: "Category name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="categoryActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editCategory?.categoryActive === "True"} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
    );
}

export default Categories;